import React, { useEffect, useState } from "react";
import { WifiSlash } from "@phosphor-icons/react";

export const OfflineBanner = () => {
  const [offline, setOffline] = useState(typeof navigator !== "undefined" && !navigator.onLine);

  useEffect(() => {
    const on = () => setOffline(false);
    const off = () => setOffline(true);
    window.addEventListener("online", on);
    window.addEventListener("offline", off);
    return () => {
      window.removeEventListener("online", on);
      window.removeEventListener("offline", off);
    };
  }, []);

  if (!offline) return null;

  return (
    <div
      className="fixed top-0 inset-x-0 z-[60] bg-amber-500 text-black text-sm font-medium px-4 py-2 flex items-center justify-center gap-2 shadow-md"
      role="status"
      data-testid="offline-banner"
    >
      <WifiSlash size={16} weight="bold" />
      You're offline — changes won't save until you're back online.
    </div>
  );
};
